import { XmUIHandler } from '../nwaswebsdk/js-es6/xmui-es6';
import Helper from './helper';
import CustomPasswordAuthenticatorSession from './password';
import CustomOtpAuthenticatorSession from './otp';
import customProcessJsonData from './processJson';
import CustomFormSession from './form';

export default class CustomUiHandler extends XmUIHandler {
  constructor(context) {
    super();
    this.helper = new Helper(context);
  }

  getInformationResponse(
    title,
    text,
    continueText,
    actionContext,
    clientContext
  ) {
    return customInformationResponse(
      title,
      text,
      continueText,
      actionContext,
      clientContext,
      this.helper
    );
  }

  getConfirmationInput(
    title,
    text,
    continueText,
    cancelText,
    actionContext,
    clientContext
  ) {
    return customConfirmationInput(
      title,
      text,
      continueText,
      cancelText,
      actionContext,
      clientContext,
      this.helper
    );
  }

  handlePolicyRejection(title, text, buttonText, failureData, actionContext, clientContext) {
    return Promise.resolve(com.ts.mobile.sdk.ConfirmationInput.create(-1));
  };

  selectAuthenticator(options, actionContext, clientContext) {
    return customSelectAuthenticator(
      options,
      actionContext,
      clientContext,
      this.helper
    );
  }

  shouldIncludeDisabledAuthenticatorsInMenu(actionContext, clientContext) {
    return false;
  }

  createPasswordAuthSession(title, username) {
    return new CustomPasswordAuthenticatorSession(title, username, this.helper);
  }

  createOtpAuthSession(title, username, possibleTargets, autoExecedTarget) {
    return new CustomOtpAuthenticatorSession(
      title,
      username,
      possibleTargets,
      autoExecedTarget,
      this.helper
    );
  }

  controlOptionForCancellationRequestInSession(validOptions, session) {
    return session.promiseCancelAction(validOptions);
  }

  processJsonData(jsonData, actionContext, clientContext) {
    return customProcessJsonData(
      jsonData,
      actionContext,
      clientContext,
      this.helper
    );
  }

  createFormSession(formId, payload) {
    return new CustomFormSession(formId, payload, this.helper);
  }
}
